'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LABEL_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__label--small'
};

exports.default = _react2.default.createClass({
  displayName: 'UIFormLabel',

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    error: _react.PropTypes.bool.isRequired,
    htmlFor: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool.isRequired,
    required: _react.PropTypes.bool.isRequired
  },

  contextTypes: {
    fieldSize: _react.PropTypes.oneOf(Object.keys(LABEL_SIZE_OPTIONS))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      required: false,
      readOnly: false
    };
  },
  getClassName: function getClassName() {
    var _props = this.props,
        className = _props.className,
        error = _props.error,
        readOnly = _props.readOnly,
        required = _props.required;

    return (0, _reactUtils.classNames)('private-form__label', LABEL_SIZE_OPTIONS[this.context.fieldSize], className, {
      'private-form__label--readonly': readOnly,
      'private-form__label--required': required,
      'error-msg': error
    });
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        htmlFor = _props2.htmlFor,
        __error = _props2.error,
        __readOnly = _props2.readOnly,
        __required = _props2.required,
        rest = _objectWithoutProperties(_props2, ['children', 'htmlFor', 'error', 'readOnly', 'required']);

    return _react2.default.createElement(
      'label',
      _extends({}, rest, { className: this.getClassName(), htmlFor: htmlFor }),
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/form/UIFormLabel.js
// module id = 338
// module chunks = 0